/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Noachievementsfound2Inputs */

const id_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pencapaian ditemukan`)
};

const ms_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pencapaian ditemui`)
};

const da_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen achievements fundet`)
};

const de_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Errungenschaften gefunden`)
};

const en_us2_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No achievements found`)
};

const es_es2_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros`)
};

const es_mx2_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros`)
};

const fil_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang achievement`)
};

const fr_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun succès trouvé`)
};

const it_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato`)
};

const hu_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található teljesítmény`)
};

const nl_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen prestaties gevonden`)
};

const no_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen prestasjoner funnet`)
};

const pl_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono osiągnięć`)
};

const pt_br2_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada`)
};

const pt_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada`)
};

const ro_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit realizări`)
};

const fi_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutuksia ei löytynyt`)
};

const sv_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prestationer hittades`)
};

const vi_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thành tích`)
};

const tr_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarım bulunamadı`)
};

const cs_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné úspěchy`)
};

const bg_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени постижения`)
};

const ru_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения не найдены`)
};

const uk_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнень не знайдено`)
};

const ar_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على إنجازات`)
};

const hi_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई उपलब्धियाँ नहीं मिलीं`)
};

const th_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบความสำเร็จ`)
};

const ja_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績が見つかりません`)
};

const zh_cn2_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到成就`)
};

const zh_hant1_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到成就`)
};

const ko_sandboxes_noachievementsfound2 = /** @type {(inputs: Sandboxes_Noachievementsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No achievements found" |
*
* @param {Sandboxes_Noachievementsfound2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_noachievementsfound2 = /** @type {((inputs?: Sandboxes_Noachievementsfound2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Noachievementsfound2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_noachievementsfound2(inputs)
	if (locale === "ms") return ms_sandboxes_noachievementsfound2(inputs)
	if (locale === "da") return da_sandboxes_noachievementsfound2(inputs)
	if (locale === "de") return de_sandboxes_noachievementsfound2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_noachievementsfound2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_noachievementsfound2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_noachievementsfound2(inputs)
	if (locale === "fil") return fil_sandboxes_noachievementsfound2(inputs)
	if (locale === "fr") return fr_sandboxes_noachievementsfound2(inputs)
	if (locale === "it") return it_sandboxes_noachievementsfound2(inputs)
	if (locale === "hu") return hu_sandboxes_noachievementsfound2(inputs)
	if (locale === "nl") return nl_sandboxes_noachievementsfound2(inputs)
	if (locale === "no") return no_sandboxes_noachievementsfound2(inputs)
	if (locale === "pl") return pl_sandboxes_noachievementsfound2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_noachievementsfound2(inputs)
	if (locale === "pt") return pt_sandboxes_noachievementsfound2(inputs)
	if (locale === "ro") return ro_sandboxes_noachievementsfound2(inputs)
	if (locale === "fi") return fi_sandboxes_noachievementsfound2(inputs)
	if (locale === "sv") return sv_sandboxes_noachievementsfound2(inputs)
	if (locale === "vi") return vi_sandboxes_noachievementsfound2(inputs)
	if (locale === "tr") return tr_sandboxes_noachievementsfound2(inputs)
	if (locale === "cs") return cs_sandboxes_noachievementsfound2(inputs)
	if (locale === "bg") return bg_sandboxes_noachievementsfound2(inputs)
	if (locale === "ru") return ru_sandboxes_noachievementsfound2(inputs)
	if (locale === "uk") return uk_sandboxes_noachievementsfound2(inputs)
	if (locale === "ar") return ar_sandboxes_noachievementsfound2(inputs)
	if (locale === "hi") return hi_sandboxes_noachievementsfound2(inputs)
	if (locale === "th") return th_sandboxes_noachievementsfound2(inputs)
	if (locale === "ja") return ja_sandboxes_noachievementsfound2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_noachievementsfound2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_noachievementsfound2(inputs)
	return ko_sandboxes_noachievementsfound2(inputs)
});
export { sandboxes_noachievementsfound2 as "sandboxes.noAchievementsFound" }